import React, { useState } from 'react';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';

const ReviewModal = ({ question, isOpen, onClose, setNotification }) => {
    const [feedback, setFeedback] = useState('');

    if (!isOpen) return null;

    const handleReviewSubmit = async (newStatus) => {
        try {
            const questionRef = doc(db, "questions", question.id);
            await updateDoc(questionRef, {
                status: newStatus,
                feedback: feedback || "(No feedback provided)"
            });
            setNotification({ type: 'success', message: `Review submitted. Status set to "${newStatus}".` });
            setFeedback('');
            onClose();
        } catch (error) {
            setNotification({ type: 'error', message: 'Failed to submit review.' });
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
            <div className="bg-white p-6 rounded-xl shadow-lg w-full max-w-2xl flex flex-col">
                <h3 className="text-xl font-bold text-slate-800 mb-4 border-b pb-3">Review Answer</h3>
                
                {/* Scrollable Content Area */}
                <div className="space-y-4 overflow-y-auto max-h-[60vh] pr-4">
                    <div>
                        <p className="font-semibold text-slate-600">Question:</p>
                        <p className="p-3 bg-slate-50 rounded-md">{question.text}</p>
                    </div>
                     <div>
                        <p className="font-semibold text-slate-600">Answer:</p>
                        <div className="prose prose-slate max-w-none p-3 border rounded-md" dangerouslySetInnerHTML={{ __html: question.answer }} />
                    </div>
                    <div>
                        <label className="font-semibold text-slate-600">Feedback:</label>
                        <textarea
                            value={feedback}
                            onChange={e => setFeedback(e.target.value)}
                            className="w-full p-2 border rounded-md mt-1"
                            placeholder="Provide constructive feedback..."
                            rows="3"
                        ></textarea>
                    </div>
                </div>

                 <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                    <button onClick={onClose} className="bg-slate-200 text-slate-800 font-semibold py-2 px-4 rounded-md hover:bg-slate-300">Cancel</button>
                    <button onClick={() => handleReviewSubmit('needs-revision')} className="bg-amber-500 text-white font-semibold py-2 px-4 rounded-md hover:bg-amber-600">Request Revisions</button>
                    <button onClick={() => handleReviewSubmit('passed')} className="bg-emerald-500 text-white font-semibold py-2 px-4 rounded-md hover:bg-emerald-600">Approve</button>
                </div>
            </div>
        </div>
    );
};

export default ReviewModal;